import React, { useEffect, useState } from "react";
import SASTApplicationList from "../components/application/SASTApplicationList";

const SASTApplicationPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const username = prompt("Enter username:");
    const password = prompt("Enter password:");

    const correctUsername = "admin";
    const correctPassword = "12345";

    if (username === correctUsername && password === correctPassword) {
      setIsAuthenticated(true);
    } else {
      alert("Invalid username or password");
      window.location.href = "/"; // redirect or close page
    }
  }, []);

  if (!isAuthenticated) {
    return null; // hide content until authenticated
  }

  return <SASTApplicationList />;
};

export default SASTApplicationPage;
